import * as React from "react";
import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import toast, { Toaster } from "react-hot-toast";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import {
  doc,
  collection,
  query,
  orderBy,
  onSnapshot,
  getDocs,
  where,
  Timestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase_conf";
import { DataGrid } from "@mui/x-data-grid";

const columns1 = [
  { id: "full_name", label: "Full Name", minWidth: 170 },
  {
    id: "address",
    label: "Geo-Location",
    minWidth: 170,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    align: "center",
    format: (value) => String(value),
  },
  {
    id: "receivedAt",
    label: "Date Received",
    minWidth: 170,
    align: "left",
    format: (value) => new Date(value.seconds * 1000).toLocaleString(),
  },
  {
    id: "timestamp",
    label: "Date Created",
    minWidth: 170,
    align: "left",
    format: (value) => new Date(value.seconds * 1000).toLocaleString(),
  },
];

export default function ReportTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [record, setRecord] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleFilter = async (from, to) => {
    const from_date = Timestamp.fromDate(new Date(from));
    const to_date = Timestamp.fromDate(new Date(to));
    const q = query(
      collection(db, "reported_incident"),
      where("timestamp", "<", to_date),
      where("timestamp", ">=", from_date)
    );
    const querySnapshot = await getDocs(q);
    let filtered_record = [];
    querySnapshot.forEach((doc) => {
      filtered_record.push({ ...doc.data(), id: doc.id });
    });
    setRecord(filtered_record);
  };

  useEffect(() => {
    let isMounted = true;
    const q = query(
      collection(db, "reported_incident"),
      orderBy("timestamp", "desc")
    );
    onSnapshot(q, (snapshot) => {
      if (isMounted) {
        setRecord(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const [open, setOpen] = React.useState(false);
  const [incident_report_id, setIncidentReportId] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpen(true);
    setIncidentReportId(id);
  };

  const columns = [
    // { field: "id", headerName: "ID", width: 170 },
    { field: "full_name", headerName: "Full Name", width: 160 },
    { field: "address", headerName: "Geo Location", width: 300 },
    {
      field: "status",
      headerName: "Status",
      width: 90,
      width: 160,
      renderCell: (props) => {
        return props.row.status === 0 ? (
          <Chip
            label="Pending"
            variant="outlined"
            color="primary"
            size="small"
          />
        ) : props.row.status === 1 ? (
          <Chip
            label="To be rescue"
            variant="outlined"
            color="secondary"
            size="small"
          />
        ) : props.row.status === 2 ? (
          <Chip
            label="Unattended"
            variant="outlined"
            color="error"
            size="small"
          />
        ) : props.row.status === 3 ? (
          <Chip
            label="Completed"
            variant="outlined"
            color="success"
            size="small"
          />
        ) : props.row.status === 4 ? (
          <Chip
            label="Invalid Report"
            variant="outlined"
            color="error"
            size="small"
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "receivedAt",
      headerName: "Date Received",
      width: 170,
      renderCell: (props) => {
        return new Date(props.row.receivedAt.seconds * 1000).toLocaleString();
      },
    },
    {
      field: "timestamp",
      headerName: "Date Created",
      width: 170,
      renderCell: (props) => {
        return new Date(props.row.timestamp.seconds * 1000).toLocaleString();
      },
    },
    {
      field: "print",
      headerName: "PRINT",
      width: 170,
      sortable: false,
      renderCell: (props) => {
        return props.row.status === 3 ? (
          <Button
            variant="outlined"
            size="small"
            href={`/print?id=${props.row.id}`}
            target={"_blank"}
            color={"success"}
          >
            VIEW
          </Button>
        ) : (
          "--"
        );
      },
    },
    {
      field: "evaluate",
      headerName: "POST EVALUATE",
      width: 170,
      sortable: false,
      renderCell: (props) => {
        return props.row.isEvaluated === 0 ? (
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleClickOpen(props.row.id)}
            color="secondary"
          >
            EVALUATE
          </Button>
        ) : props.row.status === 3 && props.row.isEvaluated === 1 ? (
          <Chip label="Done" variant="outlined" color="success" size="small" />
        ) : (
          "--"
        );
      },
    },
  ];

  const handleClose = () => {
    setOpen(false);
    setRHU(0);
    setRV(0);
    setTruck(0);
    setManlift(0);
    setIncidentReportId("");
  };

  const [rhu, setRHU] = React.useState(0);
  const [rv, setRV] = React.useState(0);
  const [truck, setTruck] = React.useState(0);
  const [manlift, setManlift] = React.useState(0);
  const handleRHUChange = (event) => {
    setRHU(event.target.value);
  };
  const handleRVChange = (event) => {
    setRV(event.target.value);
  };
  const handleTruckChange = (event) => {
    setTruck(event.target.value);
  };
  const handleManliftChange = (event) => {
    setManlift(event.target.value);
  };

  const handleSubmitForm = async () => {
    setIsLoading(true);
    const data = {
      assisted_to_rhu: rhu,
      rescue_vehicle: rv,
      truck: truck,
      manlift: manlift,
    };

    const docReports = collection(db, "admin_reports");
    let admin_report = {};
    let admin_report_id;
    const q = query(docReports, where("incident_id", "==", incident_report_id));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      admin_report = doc.data();
      admin_report_id = doc.id;
    });

    const postReportRef = doc(db, "admin_reports", admin_report_id);
    setDoc(postReportRef, data, { merge: true });

    const incidentRef = doc(db, "reported_incident", incident_report_id);
    await updateDoc(incidentRef, {
      isEvaluated: 1,
    });
    setIsLoading(false);
    setOpen(false);
    toast.success("Submitted Successfully!");
  };

  const [from_date, setFromDate] = React.useState(dayjs(new Date()));
  const [to_date, setToDate] = React.useState(dayjs(new Date()));

  useEffect(() => {
    record.map(async el => {
      const today = new Date();
      const created = new Date(el.timestamp.seconds * 1000);
      
      var Difference_In_Time = today.getTime() - created.getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      if(Difference_In_Days > 1 && el.status !== 3){
        const xRef = doc(db, "reported_incident", el.id);
        await updateDoc(xRef, {
          status: 4
        });
      }
    })
  }, [record]);

  return (
    <>
      <Paper sx={{ width: "100%", marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "12px",
          }}
        >
          <Toaster position="top-right" reverseOrder={false} />
          <Typography
            variant="h6"
            gutterBottom
            textAlign={"center"}
            style={{ marginLeft: "5px" }}
          >
            INCIDENT REPORTS
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker", "DatePicker"]}>
              <DatePicker
                label="From Date:"
                value={from_date}
                onChange={(date) => {
                  setFromDate(date);
                  handleFilter(date, to_date);
                }}
              />
              <DatePicker
                label="To Date:"
                value={to_date}
                onChange={(date) => {
                  setToDate(date);
                  handleFilter(from_date, date);
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>

        <div style={{ height: 550, width: "100%" }}>
          <DataGrid
            rows={record}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableColumnMenu
          />
        </div>
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth={true}
      >
        <DialogTitle>POST EVALUATE FORM:</DialogTitle>
        <DialogContent>
          <FormControl
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group-rhu"
              style={{ fontSize: "17px" }}
            >
              Assisted to RHU:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group-rhu"
              name="controlled-radio-buttons-group-rhu"
              value={rhu}
              onChange={handleRHUChange}
              row
            >
              <FormControlLabel
                value={1}
                control={<Radio size="small" />}
                label="YES"
              />
              <FormControlLabel
                value={0}
                control={<Radio size="small" />}
                label="NO"
              />
            </RadioGroup>
          </FormControl>

          <p style={{ fontWeight: 600 }}>Other Assist Services</p>
          <FormControl
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group-rv"
              style={{ fontSize: "17px" }}
            >
              Rescue Vehicle:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group-rv"
              name="controlled-radio-buttons-group-rv"
              value={rv}
              onChange={handleRVChange}
              row
            >
              <FormControlLabel
                value={1}
                control={<Radio size="small" />}
                label="YES"
              />
              <FormControlLabel
                value={0}
                control={<Radio size="small" />}
                label="NO"
              />
            </RadioGroup>
          </FormControl>

          <FormControl
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group-truck"
              style={{ fontSize: "17px" }}
            >
              Truck:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group-truck"
              name="controlled-radio-buttons-group-truck"
              value={truck}
              onChange={handleTruckChange}
              row
            >
              <FormControlLabel
                value={1}
                control={<Radio size="small" />}
                label="YES"
              />
              <FormControlLabel
                value={0}
                control={<Radio size="small" />}
                label="NO"
              />
            </RadioGroup>
          </FormControl>

          <FormControl
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group-manlift"
              style={{ fontSize: "17px" }}
            >
              Manlift:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group-manlift"
              name="controlled-radio-buttons-group-manlift"
              value={manlift}
              onChange={handleManliftChange}
              row
            >
              <FormControlLabel
                value={1}
                control={<Radio size="small" />}
                label="YES"
              />
              <FormControlLabel
                value={0}
                control={<Radio size="small" />}
                label="NO"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error">
            Cancel
          </Button>
          <Button onClick={handleSubmitForm} variant="outlined">
            {isLoading ? <CircularProgress size={23} /> : "Submit Form"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
